export default __webpack_public_path__ + "static/media/w2.71da9645.png";